<script lang="ts">
    import { onMount } from "svelte";
    import { userData, userSignedIn, validatedPromoCode, discount } from "../store";
    import { getUser } from "../firebaseOperations";
    import GoogleSignIn from "../GoogleSignIn.svelte";
    let promoCodeMessage = "Please Sign In!";

    const redeemPromoCode = process.env.REDEEM_PROMO_CODE;
    // const redeemPromoCode = "http://localhost:3000/redeemPromoCode";

    function savePromoCodeToLocalStorage(code) {
        localStorage.setItem("validatedPromoCode", code);
    }

    function getPromoCodeFromLocalStorage() {
        return localStorage.getItem("validatedPromoCode");
    }
    $discount = false;
    export const redeemCode = async ($validatedPromoCode) => {
        try {
            const response = await fetch(redeemPromoCode, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    code: $validatedPromoCode,
                    user: $userData.id,
                }),
            });

            const responseData = await response.json();
            console.log(response.ok)
            if (response.ok) {
                document.getElementById("promoCodeMessage").style.color =
                    "green";
                promoCodeMessage = responseData.message;
                localStorage.removeItem("validatedPromoCode");

                const user = await getUser($userData.id);
                if(responseData.type == "credits"){
                    console.log("Credits Code Redeemed");

                document.getElementById("credits").innerHTML =
                    "Credits: " + user.credits;
                }
                else if(responseData.type == "premium"){
                    console.log("Premium Code Redeemed");
                    document.getElementById("premiumTitle").hidden = false;
                }
                else if(responseData.type == "discount"){
                    console.log("Discount Code Redeemed");

                    // figure out how to display discount on textcloaker premium
                    $discount = true;
                }

            } else {
                document.getElementById("promoCodeMessage").style.color = "red";
                promoCodeMessage = responseData.message;
            }
            dispatch("success", responseData);
            document.getElementById("promoCodeMessage").innerHTML =
                promoCodeMessage;

            setTimeout(() => {
                document.getElementById("promoCodeMessage").innerHTML = "";
            }, 3000);
        } catch (error) {
            console.error(error);
            document.getElementById("promoCodeMessage").innerHTML =
                promoCodeMessage;
            localStorage.removeItem("validatedPromoCode");

        }
    }
    onMount(() => {
        console.log("onMount");
        window.onload = () => {
            const savedPromoCode = getPromoCodeFromLocalStorage();
            if (savedPromoCode) {
                validatedPromoCode.set(savedPromoCode);
            }
            if ($userSignedIn) {
                redeemCode($validatedPromoCode);
            } else {
                document.getElementById("promoCodeMessage").innerHTML = "Please sign in to redeem your promo code!";
            }
        };
    });
    // Save promo code to localStorage whenever it changes
    $: if ($validatedPromoCode) {
        console.log($validatedPromoCode);
        savePromoCodeToLocalStorage($validatedPromoCode);
        if ($userSignedIn) {
                redeemCode($validatedPromoCode);
        } 
    }
</script>

{#if !$userSignedIn}
    <div class="newSection">
        <div id="shop">
            <h3 style="text-align: center;">Promo Code</h3>
            <div
                style="font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;"
            >
                <p>
                    Thanks for joining TextCloaker! This promo code link will
                    grant you extra benefits once you sign up using Google below!
                </p>
                <br />
                <GoogleSignIn />
            </div>
        </div>
    </div>
{:else if $userSignedIn && $validatedPromoCode != ""}
    <div class="newSection">
        <div id="shop">
            <h3 style="text-align: center;">Promo Code</h3>
            <div
                style="font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;"
            >
                <p id="promoCodeMessage"></p>
            </div>
        </div>
    </div>
{/if}
